module.exports = {"body":"<p>A basement is a fantastic area of remodeling opportunity. Basements often lend\nthemselves to endless possibilities. From additional bedrooms, family rooms, game\nrooms and rec. areas. To uniquely designed craft rooms and Man Caves.</p>\n<p>When it comes to basements, Enhanced Interiors Remodeling will work for you.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./work/Basement.md
// module id = 509
// module chunks = 0